const TTBH_PRODUCT = Object.freeze({
  disabledKey: 'TTBH_PRODUCT_TITLE_DISABLED',
  value: 'Tap.Try.Buy. Now!',
})

export default TTBH_PRODUCT
